import { ShortListBarWrapper } from "components/Shortlist/ShortlistUI";
import { PACKAGE_ACTIONS, usePackage, usePackageDispatch } from "contexts/PackageContext";
import React from "react";
import { Segmented, Tooltip } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { light, solid } from "@fortawesome/fontawesome-svg-core/import.macro";

const ShortlistBar = ({}) => {
    const { view, canSendShortlist, currentPack } = usePackage();
    const { Favourites: favs } = currentPack;

    const dispatch = usePackageDispatch();

    const handleChangeView = (value) => {
        dispatch({ type: PACKAGE_ACTIONS.SET_VIEW, payload: value });
    };
    const handleOpenMessageDrawer = () => {
        dispatch({ type: PACKAGE_ACTIONS.SET_MESSAGE_DRAWER_OPEN, payload: true });
    };

    return (
        <ShortListBarWrapper>
            <Segmented
                disabled={favs.length === 0}
                options={[
                    { label: "All", value: "Package" },
                    {
                        label: (
                            <>
                                Your Shortlist <span className="shortlist-count">{favs.length}</span>
                            </>
                        ),
                        value: "Shortlist",
                        icon: <FontAwesomeIcon icon={solid("heart")} />,
                    },
                ]}
                onChange={handleChangeView}
                value={view}
                size="large"
            />
            <div className="models-group-toolbar-icons">
                {canSendShortlist && (
                    <div
                        className={`send-shortlist ${favs.length === 0 ? "disabled" : ""}`}
                        onClick={favs.length === 0 ? null : handleOpenMessageDrawer}
                    >
                        <Tooltip placement="left" title="send shortlist to booker">
                            <span className="fa-layers fa-fw fa-lg">
                                <FontAwesomeIcon icon={light("paper-plane")} />
                            </span>
                        </Tooltip>
                    </div>
                )}
            </div>
        </ShortListBarWrapper>
    );
};

export default ShortlistBar;
